import React from 'react';
import { Box, List, ListDivider, ListItemText, MenuItem } from '@fullstory/components';
import { useIntl } from 'react-intl';
import { InspectModeCard } from '../../Components/v2/InspectModeCard';

interface InspectModeSidebarRelatedSelectorListProps {
  /**
   * A list of selectors related to the current one.
   */
  relatedSelectors: Array<string>;
  /**
   * A callback to handle when a related selector is clicked.
   */
  onRelatedSelectorClick: (index: number) => void;
}

export const InspectModeSidebarRelatedSelectorList: React.FC<
  InspectModeSidebarRelatedSelectorListProps
> = ({ relatedSelectors, onRelatedSelectorClick }) => {
  const intl = useIntl();
  return (
    <InspectModeCard
      data-component="InspectModeSidebarRelatedSelectorList"
      title={intl.formatMessage({ defaultMessage: 'Related Selectors', id: 'hmU3+D' })}
    >
      <List>
        {relatedSelectors.map((relatedSelector, i) => (
          <Box key={relatedSelector}>
            <Box
              paddingTop={i > 0 ? 8 : 0}
              paddingLeft={8}
              paddingRight={8}
              paddingBottom={i < relatedSelectors.length - 1 ? 8 : 0}
            >
              <MenuItem
                onClick={e => {
                  onRelatedSelectorClick(i);
                }}
              >
                <ListItemText text={relatedSelector} />
              </MenuItem>
            </Box>
            {i !== relatedSelectors.length - 1 && <ListDivider />}
          </Box>
        ))}
      </List>
    </InspectModeCard>
  );
};
